export const INDICES_TAB_VALUES = {
  global: '1',
  asia: '2',
} as const;

export type IndicesTabValue = (typeof INDICES_TAB_VALUES)[keyof typeof INDICES_TAB_VALUES];

export const DEFAULT_INDICES_TAB_VALUE: IndicesTabValue = INDICES_TAB_VALUES.global;

export const normalizeIndicesTabValue = (
  tab: string | undefined,
): IndicesTabValue | undefined => {
  const trimmed = tab?.trim();
  if (!trimmed) return undefined;

  return trimmed === INDICES_TAB_VALUES.global || trimmed === INDICES_TAB_VALUES.asia
    ? trimmed
    : undefined;
};
